import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsKaiosComponent } from './simple-icons-kaios.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsKaiosComponent ],
    exports:      [ SimpleIconsKaiosComponent ],
    bootstrap:    []
})
export class SimpleIconsKaiosModule {}
